export const EffectiveEntryStatus = {
  After: 'AFTER',
  Closed: 'CLOSED',
  Draft: 'DRAFT',
  Loading: 'LOADING',
  Merged: 'MERGED',
  Merging: 'MERGING',
  NotReady: 'NOT_READY',
  Queued: 'QUEUED',
  Ready: 'READY',
} as const

export type EffectiveEntryStatus = (typeof EffectiveEntryStatus)[keyof typeof EffectiveEntryStatus]
